import React, { useState, useEffect } from 'react'
import { Card, CardContent, CardHeader } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useDataProvider } from 'react-admin'
import BaseOneEntityChart from './components/BaseOneEntityChart'

const useStyles = makeStyles(() => ({
  customCard: {
    marginBottom: '1rem',
  },
  section: {
    marginBottom: '1rem',
  },
}))

export const Dashboard = () => {
  const classes = useStyles()
  const dataProvider = useDataProvider()
  const [UsersTotal, setUsersTotal] = useState(0)
  const [UsersChartData, setUsersChartData] = useState([])

  const fetchTotal = async (resource, setTotal) => {
    try {
      const { total } = await dataProvider.getList(resource, {
        pagination: { page: 1, perPage: 10 },
        sort: { field: 'createdAt', order: 'DESC' },
      })
      setTotal(total)
    } catch (error) {
      console.error(`Error fetching total for ${resource}:`, error)
    }
  }

  const fetchChartData = async (resource, setChartData, label) => {
    try {
      const { data } = await dataProvider.getList(resource, {
        pagination: { page: 1, perPage: 0 },
        sort: { field: 'createdAt', order: 'ASC' },
      })

      let cumulativeTotal = 0
      const chartData = []
      const groupedData = {}

      data.forEach((item) => {
        const date = new Date(item.createdAt).toLocaleDateString('en-CA')
        groupedData[date] = (groupedData[date] || 0) + 1
      })

      for (const date in groupedData) {
        cumulativeTotal += groupedData[date]
        chartData.push({ date, [label]: cumulativeTotal })
      }

      setChartData(chartData)
    } catch (error) {
      console.error(`Error fetching chart data for ${resource}:`, error)
    }
  }

  useEffect(() => {
    fetchTotal('Users', setUsersTotal)
    fetchChartData('Users', setUsersChartData, 'Users')
  }, [dataProvider])

  return (
    <>
      <div className={classes.section}>
        <Card>
          <CardHeader title="Welcome to the administration" />
          <CardContent>
            Now you will not miss any important date. Did not miss your friend birthday or date
            of your Marriage. This service will create a proper Congratulation message, based on
            your friend bio, context of your relation ship, etc, and will send it for you in time
            to not forget cheer your friend
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader title={`Users Total: ${UsersTotal}`} />
        <BaseOneEntityChart
          data={UsersChartData}
          index="date"
          categories={['Users']}
          colors={['#3b82f6']}
        />
      </Card>
    </>
  )
}
